import { defineMessages } from 'react-intl-next';

export const externalMediaMessages = defineMessages({
	externalMediaFile: {
		id: 'fabric.editor.externalMediaFile',
		defaultMessage: 'External media file',
		description: 'External media file',
	},
});
